import dayjs from "dayjs";

import { MonthlyCashflowResult } from "@/api/generated";

export interface LoanConditionsDraft {
  loan_amount: number;
  payment_period: number;
  payment_starts_at: string;
  initial_loan_interest_rate_percentage?: number;
}

// APIの購入月追随と同じ扱い。移動先に月次実績がある場合は、元の行を動かさない。
export const purchaseLoanHistory = (
  rows: MonthlyCashflowResult[],
  previousBoughtAt: string,
  boughtAt: string
): MonthlyCashflowResult[] => {
  const previousMonth = dayjs(previousBoughtAt).format("YYYY-MM");
  const month = dayjs(boughtAt).format("YYYY-MM");
  if (previousMonth === month || rows.some((row) => dayjs(row.month).format("YYYY-MM") === month)) return rows;
  return rows.map((row) =>
    dayjs(row.month).format("YYYY-MM") === previousMonth ? { ...row, month: `${month}-01` } : row
  );
};

export const hasApplicableLoanRate = (rows: MonthlyCashflowResult[], paymentStartsAt: string): boolean =>
  rows.some((row) => row.loan_interest_rate_percentage != null && !dayjs(row.month).isAfter(dayjs(paymentStartsAt), "month"));
